import { Typography } from '@persona-id/design-tokens';
import { COLORS, SPACINGS } from 'shared/styles/variables';
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    height: 100%;
    width: 100%;
    background: ${({ theme }) => theme.color.background.secondary};
    color: ${({ theme }) => theme.color.text.primary};
    ${Typography.TextMedium};
    -webkit-font-smoothing: antialiased;

    /* For iOS scrolling */
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  a {
    color: ${({ theme }) => theme.color.text.brand};
    font-size: inherit;
    line-height: inherit;
    text-decoration: none;

    /* Only show outline when focused via keyboard */
    &:focus-visible {
      outline: ${({ theme }) => theme.color.text.brand} auto 1px;
      outline-offset: 2px;
    }
  }

  b {
    font-weight: 500;
  }

  h1 {
    ${Typography.HeadingLarge};
    margin-bottom: ${SPACINGS.base * 2}px;
    color: ${COLORS.black};
  }

  h3 {
    ${Typography.HeadingSmall};
    color: ${COLORS.gray100};
  }

  /**
   * Temporary CSS file until we commit to a grid format.
   */
  .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -${SPACINGS.base * 2}px;
    margin-left: -${SPACINGS.base * 2}px;
  }

  .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12 {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: ${SPACINGS.base * 2}px;
    padding-left: ${SPACINGS.base * 2}px;
  }

  @media (min-width: 576px) {
    .col-sm-1 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 8.333333%;
      flex: 0 0 8.333333%;
      max-width: 8.333333%;
    }
    .col-sm-2 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    .col-sm-3 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-sm-4 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
    .col-sm-5 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
    .col-sm-6 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
    .col-sm-7 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
    }
    .col-sm-8 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    .col-sm-9 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
    .col-sm-10 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 83.333333%;
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    .col-sm-11 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 91.666667%;
      flex: 0 0 91.666667%;
      max-width: 91.666667%;
    }
    .col-sm-12 {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  @page {
    size: portrait;
  }

  @media print {
    body {
      overflow: visible;
    }
  }
`;
